<template>
  <div class="mt-7 pt-56">
    <h3 class="heading-3 pb-8">{{ documents.title }}</h3>

    <div class="grid gap-y-12 md:grid-cols-2 md:gap-x-56">
      <RevButton
        v-for="item in documents.items"
        :key="item.id"
        full-width="always"
        target="_blank"
        :to="item.link"
        variant="secondary"
      >
        {{ item.label }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'

import type { SaleDetailsSection } from '~/scopes/dashboard/my-sales/adapters/getCustomerSaleDetails/getCustomerSaleDetails.adapter'

interface SaleDetailsProps {
  documents: SaleDetailsSection
}

defineProps<SaleDetailsProps>()
</script>
